import { styled } from '@ori-ui/mui';
import { useToken } from '@ori/auth';
import type { VFC } from 'react';

import { FavoritesHeartIcon } from './FavoritesHeartIcon';
import { NotificationBellIcon } from './NotificationBellIcon';
import { PbsIcon } from './PbsIcon';
import { ShoppingBagIcon } from './ShoppingBagIcon/ShoppingBagIcon';
import { VipOrderIcon } from './VipOrder';
import { SearchInput } from '~/components/SearchInput';
import { DESKTOP_BREAKPOINT } from '~/constants';
import { useAppConfigurationContext } from '~/contexts/AppConfigurationContext';
import { useMobileWidth } from '~/hooks';

const RightActionsSectionRoot = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gridColumn: '3/4',
  justifySelf: 'end',
  maxWidth: 130,
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'end',
  },

  [theme.breakpoints.up(DESKTOP_BREAKPOINT)]: {
    maxWidth: 'none',
  },
}));

export const RightActionsSection: VFC = () => {
  const isMobile = useMobileWidth();
  const { isAnonymousUser } = useToken();
  const { pbsIconInBurgerMenu } = useAppConfigurationContext();

  const showFavorites = !isAnonymousUser && !isMobile;

  return (
    <RightActionsSectionRoot>
      <SearchInput />
      {!pbsIconInBurgerMenu && <PbsIcon />}
      {!isMobile && <VipOrderIcon />}
      <NotificationBellIcon />
      {showFavorites ? <FavoritesHeartIcon /> : null}
      <ShoppingBagIcon />
    </RightActionsSectionRoot>
  );
};
